import ls from "services/ls";

// Single home for every sup.* localStorage key (SEC-05 §C). All reads/writes for
// the messenger go through here so key names + TTLs live in one place. Values are
// JSON-serialised by the local-storage package underneath ls.

const K = {
  visitor: "sup.visitor.v1", // { token, expires_at }
  cfg: (locale) => `sup.cfg.v1.${locale || "default"}`, // { at, ttl, data }
  outbox: "sup.outbox.v1", // [ { tempId, ref, body, client_ref, at } ]
  drafts: "sup.drafts.v1", // { [ref]: text }
  lastRead: "sup.lastread.v1", // { [ref]: last_message_id }
  returnTo: "sup.returnto.v1", // deep-link path to resume after login
};

const now = () => new Date().getTime();

// ---- visitor token ----
export function getVisitorToken() {
  const v = ls.get(K.visitor);
  if (!v || !v.token) return null;
  if (v.expires_at && v.expires_at < now()) return null; // expired -> re-mint
  return v.token;
}
export function setVisitorToken(token, expiresInSeconds) {
  ls.set(K.visitor, {
    token,
    expires_at: expiresInSeconds ? now() + expiresInSeconds * 1000 : null,
  });
}
export function clearVisitorToken() {
  ls.remove(K.visitor);
}

// ---- widget-config cache (TTL) ----
export function getCachedConfig(locale) {
  const v = ls.get(K.cfg(locale));
  if (!v || !v.data) return null;
  if (v.at && v.ttl && v.at + v.ttl < now()) return null;
  return v.data;
}
export function setCachedConfig(locale, data, ttlMs = 10 * 60 * 1000) {
  ls.set(K.cfg(locale), { at: now(), ttl: ttlMs, data });
}

// ---- outbox ----
export function getOutbox() {
  return ls.get(K.outbox) || [];
}
export function setOutbox(items) {
  ls.set(K.outbox, items || []);
}

// ---- drafts ----
export function getDraft(ref) {
  const all = ls.get(K.drafts) || {};
  return all[ref] || "";
}
export function setDraft(ref, text) {
  const all = ls.get(K.drafts) || {};
  if (text) all[ref] = text;
  else delete all[ref];
  ls.set(K.drafts, all);
}

// ---- last read watermark ----
export function getLastRead(ref) {
  const all = ls.get(K.lastRead) || {};
  return all[ref] || 0;
}
export function setLastRead(ref, id) {
  const all = ls.get(K.lastRead) || {};
  all[ref] = id;
  ls.set(K.lastRead, all);
}

// ---- returnTo (deep link resume after login) ----
export function getReturnTo() {
  return ls.get(K.returnTo) || null;
}
export function setReturnTo(path) {
  if (path) ls.set(K.returnTo, path);
  else ls.remove(K.returnTo);
}
